import React from 'react'
import '../styles/mandatoryHighlight.scss'

function withMandatoryHighlight(FieldComponent) {
  function Wrapped({ required, ...rest }) {
    return (
      <span className={required ? 'mpci-mandatory' : undefined} style={{ display: 'contents' }}>
        <FieldComponent required={required} {...rest} />
      </span>
    )
  }
  return Wrapped
}

export default withMandatoryHighlight
